import { connect } from "react-redux";
import { RootState, TypedDispatch } from "../../../../redux/store";
import { SettingsInitialStateDTO } from "../service/types";
import { getRoleById } from "../service/settingsSlice";
import { getStaffList } from "../../Manage/ManageStaff/service/Staffslice";
import SystemRoleDetail from "../components/RolesAndPermission/components/SystemRoleDetail/SystemRoleDetail";

interface DispatchProps {
  GetStaffList(id: string): void;
  GetRoleById(id: string): void;
}

const mapStateToProps = (state: RootState): SettingsInitialStateDTO => {
  return {
    notifySettings: state.appSettings.notifySettings,
    invoiceSettings: state.appSettings.invoiceSettings,
    rolesList: state.appSettings.rolesList,
    roleDomainStructure: state.appSettings.roleDomainStructure,
    roleById: state.appSettings.roleById,
    studentIdData: state.appSettings.studentIdData,
    customFields: state.appSettings.customFields,
    activeLeadForm: state.appSettings.activeLeadForm,
    leadFormById: state.appSettings.leadFormById,
    leadForms: state.appSettings.leadForms,
    createdLeadFormId: state.appSettings.createdLeadFormId,

    success: state.appSettings.success,
    error: state.appSettings.error,
    loading: state.appSettings.loading,
    notifySettingLoading: state.appSettings.notifySettingLoading,
    notifySettingUpdateLoading: state.appSettings.notifySettingUpdateLoading,
    notifySettingUpdateSuccess: state.appSettings.notifySettingUpdateSuccess,
    notifySettingUpdateError: state.appSettings.notifySettingUpdateError,
    invoiceSettingLoading: state.appSettings.invoiceSettingLoading,
    invoiceSettingCreateLoading: state.appSettings.invoiceSettingCreateLoading,
    invoiceSettingCreateSuccess: state.appSettings.invoiceSettingCreateSuccess,
    invoiceSettingCreateError: state.appSettings.invoiceSettingCreateError,
    invoiceSettingUpdateLoading: state.appSettings.invoiceSettingUpdateLoading,
    invoiceSettingUpdateSuccess: state.appSettings.invoiceSettingUpdateSuccess,
    invoiceSettingUpdateError: state.appSettings.invoiceSettingUpdateError,
    invoiceFooterUpdateLoading: state.appSettings.invoiceFooterUpdateLoading,
    invoiceFooterUpdateSuccess: state.appSettings.invoiceFooterUpdateSuccess,
    invoiceFooterUpdateError: state.appSettings.invoiceFooterUpdateError,
    createCustomRoleError: state.appSettings.createCustomRoleError,
    createCustomRoleSuccess: state.appSettings.createCustomRoleSuccess,
    createCustomRoleLoading: state.appSettings.createCustomRoleLoading,
    rolesListLoading: state.appSettings.rolesListLoading,
    roleDomainStructureLoading: state.appSettings.roleDomainStructureLoading,
    updateCustomRoleError: state.appSettings.updateCustomRoleError,
    updateCustomRoleSuccess: state.appSettings.updateCustomRoleSuccess,
    updateCustomRoleLoading: state.appSettings.updateCustomRoleLoading,
    roleByIdLoading: state.appSettings.roleByIdLoading,
    deleteCustomRoleError: state.appSettings.deleteCustomRoleError,
    deleteCustomRoleSuccess: state.appSettings.deleteCustomRoleSuccess,
    deleteCustomRoleLoading: state.appSettings.deleteCustomRoleLoading,
    createStudentIdError: state.appSettings.createStudentIdError,
    createStudentIdSuccess: state.appSettings.createStudentIdSuccess,
    createStudentIdLoading: state.appSettings.createStudentIdLoading,
    updateStudentIdError: state.appSettings.updateStudentIdError,
    updateStudentIdSuccess: state.appSettings.updateStudentIdSuccess,
    updateStudentIdLoading: state.appSettings.updateStudentIdLoading,
    StudentIdDataLoading: state.appSettings.StudentIdDataLoading,
    customFieldsLoading: state.appSettings.customFieldsLoading,

    createLeadFormSuccess: state.appSettings.createLeadFormSuccess,
    createLeadFormLoading: state.appSettings.createLeadFormLoading,
    updateLeadFormSuccess: state.appSettings.updateLeadFormSuccess,
    updateLeadFormLoading: state.appSettings.updateLeadFormLoading,
    updateCustomFieldsSuccess: state.appSettings.updateCustomFieldsSuccess,
    updateCustomFieldsLoading: state.appSettings.updateCustomFieldsLoading,
    activeLeadFormLoading: state.appSettings.activeLeadFormLoading,
    leadFormByIdLoading: state.appSettings.leadFormByIdLoading,
    leadFormsLoading: state.appSettings.leadFormsLoading,

    // purchase History
    purchaseHistory: state.appSettings.purchaseHistory,
    purchaseHistoryLoading: state.appSettings.purchaseHistoryLoading,
    purchaseHistorySuccess: state.appSettings.purchaseHistoryLoading,
    purchaseHistoryError: state.appSettings.purchaseHistoryError,

    // updatePayment Link
    paymentlink: state.appSettings.paymentlink,
    paymentLinkLoading: state.appSettings.paymentLinkLoading,
    paymentLinkSuccess: state.appSettings.paymentLinkSuccess,
    paymentLinkError: state.appSettings.paymentLinkError,

    // Enquiry Tags
    enquiryTags: state.appSettings.enquiryTags,
    enquiryTagsLoading: state.appSettings.enquiryTagsLoading,
    createEnquiryTagLoading: state.appSettings.createEnquiryTagLoading,
    createEnquiryTagSuccess: state.appSettings.createEnquiryTagSuccess,
    createEnquiryTagError: state.appSettings.createEnquiryTagError,
    deleteEnquiryTagLoading: state.appSettings.deleteEnquiryTagLoading,
    deleteEnquiryTagSuccess: state.appSettings.deleteEnquiryTagSuccess,
    deleteEnquiryTagError: state.appSettings.deleteEnquiryTagError,
  };
};

const mapDispatchToProps = (dispatch: TypedDispatch): DispatchProps => {
  return {
    GetStaffList: (id: string) => {
      dispatch(getStaffList(id));
    },
    GetRoleById: (id: string) => {
      dispatch(getRoleById(id));
    },
  };
};

export interface SystemRoleDetailProps
  extends SettingsInitialStateDTO,
  DispatchProps { }
export const SystemRoleDetailComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(SystemRoleDetail);
